import videojs from 'video.js';

const Plugin = videojs.getPlugin('plugin');
const Component = videojs.getComponent('Component');
const MenuButton = videojs.getComponent('MenuButton');

class SettingsMenuButton extends MenuButton {
  constructor(player, options) {
    super(player, options);
    this.controlText('Настройки');
    this.isDisableClick = false;
  }

  buildCSSClass() {
    return `vjs-settings-button ${super.buildCSSClass()}`;
  }

  buildWrapperCSSClass() {
    return `vjs-settings-button-container ${super.buildWrapperCSSClass()}`;
  }

  handleClick() {
    if (this.isDisableClick) return;
    const settingsMenu = this.player().getChild('settingsMenu');
    settingsMenu.hasClass('vjs-hidden') ? settingsMenu.show() : settingsMenu.hide();
  }

  enableOpacity() {
    this.addClass('vjs-settings-button_opacity');
  }

  disableOpacity() {
    this.removeClass('vjs-settings-button_opacity');
  }
}

Component.registerComponent('settingsMenuButton', SettingsMenuButton);